import { defineStore } from 'pinia';
import api from '../../api';

export const useSecurityStore = defineStore('security', {
  state: () => ({
    vlanList: [],
    radiusPortConfig: [],
    radiusConfig: {}
  }),

  actions: {
    setRadiusInfo(data) {
      console.log('setRadiusInfo-WS::', data);
      this.radiusConfig = data;
    },
    setRadiusPortConfig(data) {
      this.radiusPortConfig = data.radiusPortConfig;
    },
    queryRadiusInfo() {
      return api.security.queryRadiusInfo()
        .then(data => {
          if (data.resp.respCode === 0 && data.radiusConfig) {
            this.radiusConfig = data.radiusConfig;
          }
          return data;
        })
        .catch(error => { throw error; });
    },

    updateRadiusInfo(params) {
      return api.security.updateRadiusInfo(params)
        .then(data => data)
        .catch(error => { throw error; });
    },

    deleteRadiusInfo(params) {
      return api.security.deleteRadiusInfo(params)
        .then(data => data)
        .catch(error => { throw error; });
    },

    queryAccessControlList() {
      return api.security.queryAccessControlList()
        .then(data => data)
        .catch(error => { throw error; });
    },

    deleteAccessControlList(params) {
      return api.security.deleteAccessControlList(params)
        .then(data => data)
        .catch(error => { throw error; });
    },

    updateAccessControlList(params) {
      return api.security.updateAccessControlList(params)
        .then(data => data)
        .catch(error => { throw error; });
    },

    queryRadiusPortConfig() {
      return api.security.queryRadiusPortConfig()
        .then(data => {
          if (data.resp.respCode === 0) {
            //this.setRadiusPortConfig(data.radius_port_config.radiusPortConfig);
            this.radiusPortConfig = data.radius_port_config.radiusPortConfig;
          }
          return data;
        })
        .catch(error => { throw error; });
    },

    updateRadiusPortConfig(params) {
      return api.security.updateRadiusPortConfig(params)
        .then(data => data)
        .catch(error => { throw error; });
    }
  }
});